<template>
  <!--  解绑确认弹窗 -->
  <mk-dialog
    width="456px"
    :visible="visible"
    :class="{'dialog-input': dialogStatus === 2}"
    class="unbind-dialog"
    @close="dialogCancel"
  >
    <div
      class="dialog-title"
    >
      <span v-if="dialogStatus === 1">
        <ds-iconfont icon-class="icon-mk-guanbihuojingshihuocuowu" />
        是否解绑小程序？
      </span>
      <span v-else>
        解绑小程序
      </span>
      <span class="close">
        <i
          class="el-icon-close"
          @click="$emit('update:visible', false)"
        ></i>
      </span>
    </div>
    <div
      v-if="dialogStatus === 1"
      class="dialog-text"
    >
      <div>解绑小程序将导致以下情况，请谨慎操作：</div>
      <div class="mr-top-4">
        1、智能名片不可用
      </div>
      <div>2、小程序素材不可用</div>
    </div>
    <div
      v-else
      class="dialog-unbind-status"
    >
      <div class="unbinding-mention">
        <ds-iconfont icon-class="icon-mk-guanbihuojingshihuocuowu" />
        解绑将导致原有小程序不可访问请谨慎操作
      </div>
      <!-- 验证码表单 -->
      <mk-form
        ref="unbindForm"
        class="code-form"
        :model="codeForm"
        :rules="rules"
      >
        <mk-form-item
          label="登录账号："
          prop="phone"
          class="first-item"
        >
          {{ codeForm.phoneNumber }}
        </mk-form-item>
        <mk-form-item
          label="验证码："
          prop="code"
        >
          <mk-input
            v-model="codeForm.code"
            type="text"
            height="32"
            width="230"
            maxlength="6"
            placeholder="验证码"
          >
            <mk-button
              slot="suffix"
              class="form-captcha__suffix"
              type="text"
              :disabled="!showSent"
              size="mini"
              @click="getCode"
            >
              <template v-if="showSent">
                发送验证码
              </template>
              <template v-else>
                {{ count }}s重新发送
              </template>
            </mk-button>
          </mk-input>
        </mk-form-item>
      </mk-form>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <mk-button
        size="medium"
        @click="dialogCancel"
      >取消</mk-button>
      <mk-button
        class="confirm-unbind"
        size="medium"
        @click="nextStatus"
      >确定</mk-button>
    </span>
  </mk-dialog>
</template>

<script>
export default {
  name: 'UnbindDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 弹窗当前内容
      dialogStatus: 1,
      codeForm: {
        phoneNumber: '',
        code: ''
      },
      // 倒计时
      showSent: true,
      count: '', // 初始化次数
      timer: null,
      timeCount: 60,
      rules: {
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.getPhoneNumber()
  },
  methods: {
    nextStatus () {
      if (this.dialogStatus === 1) {
        this.dialogStatus = 2
      } else {
        this.unbundele()
      }
    },
    // 获取管理员绑定手机号
    async getPhoneNumber () {
      let res = await BIZAPIS.ManageApi.authManagePhoneGet()
      if (res.success) {
        this.codeForm.phoneNumber = res.data
      }
    },
    // 关闭弹框
    dialogCancel () {
      this.$emit('update:visible', false)
      this.$emit('on-close')
      this.initCode()
      this.$refs['unbindForm'].resetFields()
      this.dialogStatus = 1
    },
    // 验证码倒计时初始化
    initCode () {
      this.showSent = true
      clearInterval(this.timer) // 清除定时器
      this.timer = null
      this.count = ''
    },
    // 获取验证码
    getCode () {
      if (!this.timer) {
        this.count = this.timeCount
        this.showSent = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= this.timeCount) {
            this.count--
          } else {
            this.initCode()
          }
        }, 1000)
      }
      this.getCodeApi()
    },
    // 请求短信验证码接口
    async getCodeApi () {
      let params = {
        phone: this.codeForm.phoneNumber,
        expire: 1,
        length: 6,
        type: 1
      }
      let res = await BIZAPIS.SmsApi.smsWeixinAuthSendSmsCodePost(params)
    },
    // 解绑接口（含验证码校验
    unbundele () {
      this.$refs['unbindForm'].validate((valid) => {
        if (valid) {
          this.authManageWeixinMiniDelete()
        } else {
          return false
        }
      })
    },
    async authManageWeixinMiniDelete () {
      let params = {
        code: this.codeForm.code,
        phone: this.codeForm.phoneNumber
      }
      let res = await BIZAPIS.ManageMiniApi.authManageWeixinMiniDelete(params)
      if (res.success) {
        this.$message.success('解绑成功')
        // 成功后关闭弹窗，重载页面
        location.reload()
      } else if (res.data === false) {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-unbind {
  color: #f5222d;
  background: rgba(0, 0, 0, 0.04);
}

/deep/ .el-dialog__header {
  display: none;
}

.dialog-title {
  height: 24px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #262626;

  .icon-mk-guanbihuojingshihuocuowu {
    font-size: 19px;
    margin-right: 11px;
    color: #e62412;
  }

  .el-icon-close {
    color: #bfbfbf;
    cursor: pointer;
  }
}

.dialog-text {
  padding-left: 35px;
  margin-top: 12px;
  color: #595959;
  line-height: 20px;

  .mr-top-4 {
    margin-top: 4px;
  }
}

.unbind-dialog {
  /deep/ .el-dialog__body {
    padding: 17px 22px 28px !important;
  }
}

/deep/ .el-dialog__footer {
  padding-top: 0 !important;
}

.form-captcha__suffix {
  font-size: 13px;
}

.first-item {
  margin: 25px 0 12px;

  /deep/ .el-form-item__content {
    line-height: 18px;
  }

  /deep/ .el-form-item__label {
    line-height: 18px;
  }
}

/deep/ .el-form-item__error {
  padding-left: 78px;
}

.unbinding-mention {
  margin-top: 16px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 36px;
  background: rgba(255, 237, 237, 1);
  border-radius: 4px;
  border: 1px solid rgba(255, 204, 204, 1);
  color: #262626;

  .icon-mk-guanbihuojingshihuocuowu {
    font-size: 16px;
    color: #e62412;
    margin: 0 10px;
  }
}

.dialog-input {
  /deep/ .el-dialog__body {
    padding: 0 !important;
  }

  .dialog-title {
    height: 54px;
    line-height: 54px;
    padding: 0 20px;
    border-bottom: 1px solid #e8e8e8;
    background-color: rgba(251, 252, 253, 1);
  }

  .dialog-unbind-status {
    padding: 0 20px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  }

  /deep/ .el-dialog__footer {
    margin-top: 12px;
    padding-bottom: 12px !important;
  }
}
</style>
